var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-timerange-picker.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-formfield-wrapper.js";
import { FormField } from "@adornis/formfield/form-field.js";
import "@adornis/forms/x-input.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { ref } from "lit/directives/ref.js";
import { DateTime } from "luxon";
var XTimeRangePicker = class extends FormField {
  constructor() {
    super(...arguments);
    this.value = new RXController(this, null);
  }
  render() {
    return html`
      <x-dropdown
        ${css({ cursor: "pointer" })}
        @value-picked=${(e) => {
      this.value.next(e.detail.value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
    }}
        ${ref((dropdown) => this._adropdown = dropdown)}
      >
        <x-formfield-wrapper
          ${injectAttributesOf(this, ["tabindex"])}
          ?show-label=${!!this.value.value}
          one-line
          slot="trigger"
          @click=${() => this._adropdown?.toggle()}
          @cleared=${() => {
      this.value.next(null);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: null } }));
    }}
        >
          <x-text tone=${ifDefined(!this.value.value ? "placeholder" : void 0)}>
            ${this.value.value ? this.value.value[0].toLocaleString(DateTime.TIME_SIMPLE) + " - " + this.value.value[1].toLocaleString(DateTime.TIME_SIMPLE) : this.placeholder ?? "Zeitraum ausw\xE4hlen"}
          </x-text>
        </x-formfield-wrapper>
        <x-timerange-picker-dropdown
          slot="dropdown-content"
          .date=${this.value.value?.[0]}
          .date2=${this.value.value?.[1]}
        ></x-timerange-picker-dropdown>
      </x-dropdown>
    `;
  }
};
__decorateClass([
  property()
], XTimeRangePicker.prototype, "placeholder", 2);
XTimeRangePicker = __decorateClass([
  customElement("x-timerange-picker")
], XTimeRangePicker);
var XTimeRangePickerDropdown = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.date = DateTime.now();
    this.date2 = DateTime.now().plus({ minute: 1 });
  }
  receiveTrigger(trigger) {
    this._trigger = trigger;
  }
  render() {
    return html`
      <x-flex padding="sm" space="md" ${css({ background: this.colors.white })}>
        <x-input
          type="time"
          .value=${this.date}
          @value-picked=${(e) => this.date = e.detail.value}
        ></x-input>
        <x-input
          type="time"
          .value=${this.date2}
          @value-picked=${(e) => this.date2 = e.detail.value}
        ></x-input>
        <x-flex horizontal space="md">
          <x-button
            @click=${() => {
      this._trigger?.dispatchEvent(
        new CustomEvent("value-picked", { detail: { value: [this.date, this.date2] } })
      );
      this._trigger?.toggle();
    }}
          >
            Speichern
          </x-button>
          <x-button mode="outline" @click=${() => this._trigger?.toggle()}> Schließen </x-button>
        </x-flex>
      </x-flex>
    `;
  }
};
__decorateClass([
  state()
], XTimeRangePickerDropdown.prototype, "date", 2);
__decorateClass([
  state()
], XTimeRangePickerDropdown.prototype, "date2", 2);
XTimeRangePickerDropdown = __decorateClass([
  customElement("x-timerange-picker-dropdown")
], XTimeRangePickerDropdown);
export {
  XTimeRangePicker,
  XTimeRangePickerDropdown
};
